module.exports = __webpack_public_path__ + "img/instagram.d29e073f.svg";